if (!customElements.get("hero-grid-siwper")) {
    class HeroGridSwiper extends HTMLElement {
        constructor() {
            super();
            this.swiperInstance = null; // 保存 Swiper 实例
            this.mediaQuery = window.matchMedia('(max-width: 1000px)');
            this.checkWidth = this.checkWidth.bind(this); // 绑定方法
            this.resizeTimeout = null; // 防抖计时器
            this.mediaQuery.addEventListener('change', this.checkWidth); // 监听媒体查询变化
        }

        connectedCallback() {
            this.checkWidth(this.mediaQuery); // 初始化时检查宽度
        }

        checkWidth(event) {
            if (event.matches) {
                this.initSwiper();
            } else {
                this.removeSwiper();
            }
        }

        initSwiper() {
            const swiperContainer = this.querySelector('.swiper');
            if (swiperContainer && !this.swiperInstance) { // 确保 Swiper 只初始化一次
                this.swiperInstance = new Swiper(swiperContainer, {
                    slidesPerView: 1.1,
                    spaceBetween: 16,
                    pagination: {
                        el: this.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                });
                this.setPaginationPosition();
                
                // 监听窗口大小变化
                window.addEventListener('resize', this.debounceResize.bind(this), { passive: true });
            }
        }

        debounceResize() {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(() => {
                this.setPaginationPosition();
            }, 1000); // 1秒防抖
        }

        setPaginationPosition() {
            const pagination = this.swiperInstance.pagination.$el[0];
            const itemContent = this.querySelector('.hero-grid-show-box_slideshow_mb_item_content');
            if (itemContent && pagination) {
                const top = itemContent.clientHeight;
                const marginTop = parseFloat(getComputedStyle(itemContent).marginTop) || 0; // 确保为数字
                const paginationHeight = pagination.clientHeight;
                const paginationTopValue = top + (marginTop / 2) - (paginationHeight / 2);
                pagination.style.setProperty('--pagination-top', `${paginationTopValue}px`); // 设置 CSS 变量
                console.log(top, marginTop, paginationHeight, paginationTopValue);
                return paginationTopValue; // 返回 paginationTopValue
            }
            return null; // 如果没有找到内容，返回 null
        }

        removeSwiper() {
            if (this.swiperInstance) {
                this.swiperInstance.destroy(); // 销毁 Swiper 实例
                this.swiperInstance = null; // 清空实例
                window.removeEventListener('resize', this.debounceResize.bind(this)); // 移除事件监听
            }
        }

        disconnectedCallback() {
            this.mediaQuery.removeEventListener('change', this.checkWidth); // 清理事件监听
            window.removeEventListener('resize', this.debounceResize.bind(this)); // 清理事件监听
        }
    }
    customElements.define('hero-grid-siwper', HeroGridSwiper);
}
